var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-LinkedIn",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.68520125,13.9850649 L7.68520125,23.9477273 L4,23.9477273 L4,13.9850649 L7.68520125,13.9850649 Z M16.3131237,13.9850649 C18.5866711,13.9850649 20.2148855,15.2368763 20.2148855,17.8264734 L20.2148855,17.8264734 L20.2148855,23.9477273 L16.9111052,23.9477273 L16.9111052,23.9477273 L16.9111052,18.8727999 C16.9111052,17.4813564 16.3239469,16.7039285 15.1036317,16.7039285 C13.774408,16.7039285 13.0810471,17.513673 13.0810471,18.8727999 L13.0810471,18.8727999 L13.0810471,23.9477273 L9.896322,23.9477273 L9.896322,14.2801827 L13.0810471,14.2801827 L13.0810471,15.5826031 C13.0810471,15.5826031 14.0382234,13.9850649 16.3131237,13.9850649 Z M5.84260062,10 C6.86041207,10 7.68520125,10.7433976 7.68520125,11.6604437 C7.68520125,12.5769224 6.86041207,13.3208874 5.84260062,13.3208874 C4.82415424,13.3208874 4,12.5769224 4,11.6604437 C4,10.7433976 4.82415424,10 5.84260062,10 Z",
    id: "Combined-Shape",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.396bc488.svg";
export { ForwardRef as ReactComponent };